import { useEffect } from 'react';
import { Calendars } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useCalendars() {
  const auctions = useAxios(
    (axios, signal) =>
      axios.request<Calendars>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/auctions/calendars`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    auctions.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return auctions;
}

export type CalendarsRequest = ReturnType<typeof useCalendars>;
